import { Form, Upload, message, Image } from "antd";
import { useEffect, useState } from "react";
import Resizer from "react-image-file-resizer";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";

const ConsultationPhoto = ({ onPhotosChange }) => {
  // -------------------------- VAR ----------------------------
  const form = Form.useFormInstance();
  const photos = Form.useWatch("photo", form) || [];

  // now an array of { uid, file, uri }
  const [images, setImages] = useState(photos);

  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT -------------------------

  // keep form in sync
  useEffect(() => {
    // form.setFieldValue("photo", images);
    onPhotosChange(images);
    console.log({ photos, images });
  }, [images, form]);
  // -------------------------- FUNCTION -----------------------

  const beforeUpload = (file) => {
    const isImg = ["image/jpeg", "image/png"].includes(file.type);
    if (!isImg) message.error("You can only upload JPG/PNG!");
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) message.error("Image must be smaller than 5MB!");
    return isImg && isLt5M;
  };

  const handleUpload = ({ file, onSuccess, onError }) => {
    // give each image a unique uid
    const uid = `${file.name}-${Date.now()}`;
    // show loader
    setImages((imgs) => [...imgs, { uid, file, uri: null }]);

    // resize & replace placeholder item
    Resizer.imageFileResizer(
      file,
      1920,
      1080,
      "JPEG",
      100,
      0,
      (uri) => {
        setImages((imgs) =>
          imgs.map((img) => (img.uid === uid ? { ...img, uri } : img))
        );
        onSuccess("ok");
      },
      "base64"
    );
  };

  const handleRemove = (file) => {
    setImages((imgs) => imgs.filter((img) => img.uid !== file.uid));
  };

  // build AntD’s fileList from our state
  const fileList = images.map((img) => ({
    uid: img.uid,
    name: img.file.name,
    url: img.uri,
  }));

  // -------------------------- RENDER -------------------------
  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  // -------------------------- MAIN ---------------------------

  return (
    <Form.Item
      form={form}
      label="Feel free to send a current photo of your lips or brows — it’ll help us
give you the best advice (maximum of 2 photos)"
      name="photo"
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
    >
      <Upload
        listType="picture-card"
        fileList={fileList}
        onRemove={handleRemove}
        beforeUpload={beforeUpload}
        customRequest={handleUpload}
        multiple
        maxCount={2}
      >
        {uploadButton}
      </Upload>
    </Form.Item>
  );
};

export default ConsultationPhoto;
